<template>
  <div>
    <div class="tabs is-toggle is-fullwidth lxm-bottom-tabs">
      <ul>
        <template v-for="tab in tabs">
          <li class="lxm-bottom-tabs__li" :class="{ 'is-active': tab.active }">
            <a @click="tabClicked(tab)">
              <div class="lxm-bottom-tabs__tab">
                <div class="lxm-bottom-tabs__icon-container">
                  <div class="lxm-bottom-tabs__icon" :class="iconClass(tab)"></div>
                </div>
                <div>{{ tab.name }}</div>
              </div>
            </a>
          </li>
        </template>
      </ul>
    </div>
    <div class="lxm-bottom-tabs-placeholder"></div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  tab-height = footer-bar-height
  .lxm-bottom-tabs
    position: fixed
    bottom: 0
    width: 100vw
    box-shadow: tabs-box-shadow
    &:not(:last-child)
      margin-bottom: 0
    &.tabs.is-toggle
      li a
        padding: 0 !important
        border: 0 !important
        border-radius: 0 !important
        background-color: brand-primary
        color: white
      li.is-active a
        background-color: brand-secondary
        color: brand-primary
  .lxm-bottom-tabs__li
    width: 20%
  .lxm-bottom-tabs__tab
    height: tab-height
    font-size: siz(13)
    line-height: 1
  .lxm-bottom-tabs__icon-container
    height: siz(36)
    display: flex
    justify-content: center
    align-items: center
  .lxm-bottom-tabs__icon
    background-repeat: no-repeat
    background-size: 100%

  .lxm-bottom-tabs__icon--dashboard, .lxm-bottom-tabs__icon--dashboard-selected
    width: siz(22)
    height: siz(21.5)
  .lxm-bottom-tabs__icon--dashboard
    background-image: url('../../images/main/tab-dashboard.png')
  .lxm-bottom-tabs__icon--dashboard-selected
    background-image: url('../../images/main/tab-dashboard-selected.png')

  .lxm-bottom-tabs__icon--contact, .lxm-bottom-tabs__icon--contact-selected
    width: siz(22)
    height: siz(20.5)
  .lxm-bottom-tabs__icon--contact
    background-image: url('../../images/main/tab-contact.png')
  .lxm-bottom-tabs__icon--contact-selected
    background-image: url('../../images/main/tab-contact-selected.png')

  .lxm-bottom-tabs__icon--form, .lxm-bottom-tabs__icon--form-selected
    width: siz(25.5)
    height: siz(21.5)
  .lxm-bottom-tabs__icon--form
    background-image: url('../../images/main/tab-form.png')
  .lxm-bottom-tabs__icon--form-selected
    background-image: url('../../images/main/tab-form-selected.png')

  .lxm-bottom-tabs__icon--cf, .lxm-bottom-tabs__icon--cf-selected
    width: siz(24)
    height: siz(21.5)
  .lxm-bottom-tabs__icon--cf
    background-image: url('../../images/main/tab-cf.png')
  .lxm-bottom-tabs__icon--cf-selected
    background-image: url('../../images/main/tab-cf-selected.png')

  .lxm-bottom-tabs__icon--activity, .lxm-bottom-tabs__icon--activity-selected
    width: siz(18.5)
    height: siz(21.5)
  .lxm-bottom-tabs__icon--activity
    background-image: url('../../images/main/tab-activity.png')
  .lxm-bottom-tabs__icon--activity-selected
    background-image: url('../../images/main/tab-activity-selected.png')

  .lxm-bottom-tabs-placeholder
    height: tab-height
</style>

<script>
  import * as mTypes from '../../../store/mutation-types'
  export default {
    computed: {
      tabs () {
        const ret = [{
          icon: 'dashboard',
          name: '工作看板',
          path: '/main/dashboard'
        }, {
          icon: 'contact',
          name: '联系人',
          path: '/main/contact'
        }, {
          icon: 'form',
          name: '表单',
          path: '/main/form'
        }, {
          icon: 'cf',
          name: '收款',
          path: '/main/cf'
        }, {
          icon: 'activity',
          name: '活动',
          path: '/main/activity'
        }]
        ret.forEach(t => {
          // t.href = `/#${t.path}`
          t.active = this.$route.path.indexOf(t.path) === 0
        })
        return ret
      }
    },
    methods: {
      iconClass (tab) {
        return tab.active ? `lxm-bottom-tabs__icon--${tab.icon}-selected` : `lxm-bottom-tabs__icon--${tab.icon}`
      },
      tabClicked (tab) {
        if (tab.path) {
          this.$store.commit(mTypes.TRANSITION_SET_BACK)
          this.$router.push(tab.path)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmBottomTabs.vue?b5d3ae54